import {ProductTypeEnum} from "../enums/ProductType.enum";

export const InterchangeableLensCameraTypes = [ProductTypeEnum.MIRRORLESS, ProductTypeEnum.REFLEX];
export const FixedLensCameraTypes = [ProductTypeEnum.BRIDGE, ProductTypeEnum.COMPATTA];
export const AllCameraTypes = [...InterchangeableLensCameraTypes, ...FixedLensCameraTypes];
export const LensTypes = [ProductTypeEnum.OBIETTIVO];
export const AllProductTypes = [...AllCameraTypes, ...LensTypes];
